import { render, staticRenderFns } from "./BldUniPost.vue?vue&type=template&id=97114040&scoped=true&"
import script from "./BldUniPost.vue?vue&type=script&lang=js&"
export * from "./BldUniPost.vue?vue&type=script&lang=js&"
import style0 from "./BldUniPost.vue?vue&type=style&index=0&id=97114040&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97114040",
  null
  
)

export default component.exports